<div class="admin-list-item-root">
  <div class="general-data">
    <div class="picture">
      <img src="{{ admin.picture }}" *ngIf="admin.picture" alt="{{alt}}">
      <nb-icon icon="person-outline" *ngIf="!admin.picture"></nb-icon>
    </div>
    <div class="name-email">
      <span class="name" matTooltip="{{admin.name}}" matTooltipPosition="above" matTooltipClass="name-tooltip" matTooltipDisabled="{{maxNameLength(admin.name)}}">{{admin.name}}</span>
      <span class="email"matTooltip="{{admin.email}}" matTooltipPosition="above" matTooltipClass="name-tooltip" matTooltipDisabled="{{maxNameLength(admin.email)}}">{{admin.email}}</span>
    </div>
  </div>
  <div class="region-level">
    <app-multi-select *ngIf="!isGlobalAdmin"
    #regionMultiSelect
    [options]="availableRegions"
    [initialMultiData]="mappedRegions"
    [isMultiselector]="true"
    [entity]="'Regions'"
    (valueChange)="handleRegionChange($event)"
    (closedWithChanges)="handleSaveRegionChange()"
    ></app-multi-select>
    <span *ngIf="isGlobalAdmin">{{allRegions}}</span>
  </div>
  <div class="region-level">
    <app-multi-select *ngIf="!isLoggedUser"
      #roleSelect
      [options]="availableRoles"
      [initialData]="mappedRole"
      (valueChange)="handleRoleChange($event)"
      ></app-multi-select>
      <span *ngIf="isLoggedUser">{{loggedUserRole}}</span>
  </div>
  <button *ngIf="!isLoggedUser" class="delete-btn" mat-icon-button (click)="deleteAdmin($event)">
    <nb-icon icon="trash-2-outline"></nb-icon>
  </button>
</div>
<div class="admin-list-item-divider"></div>
